module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image39.1db57caa.webp";